import { makeStyles } from '@material-ui/core/styles';

const SupporterSummaryStyles =
    makeStyles((theme) => ({
        supporterSummaryStyles: {
            margin: "10px",
            display: "inline-block", 
            textAlign: "center",
            color: theme.palette.text.secondary,
        },
        supporterSummaryImgContainerStyles: {
            maxWidth: "180px",
            maxHeight: "180px",
            padding: "15px",
            overflow: "hidden",
            display: "inline-block",
            borderRadius: "50%",
            backgroundColor: "white",
        },
        supporterSummaryImgStyles: {
            width: "150px", 
            height: "150px",
            backgroundColor: theme.palette.background.paper,
        },
    }));

export default SupporterSummaryStyles;
